<template>
  <div>
    <div class="row">
      <div class="col-md-6 col-sm-12">
        <title-bread-crumb :page="page" />
      </div>
      <div class="col-md-6 col-sm-12">
        <div class="row">
          <div class="col-12">
            <div class="text-right">
              <ActionButton
                variant="outline-success pl-4 pr-4 mt-2"
                i="fas fa-arrow-circle-left"
                @click="$router.push('/student/interview')"
              >
                Regresar
              </ActionButton>

              <ActionButton
                v-if="!model.isSubmitted"
                variant="outline-success ml-2 pl-4 pr-4 mt-2"
                type="submit"
                i="fas fa-flag-alt"
                @click="handleSubmit(apiActions.SUBMIT)"
              >
                Someter
              </ActionButton>
              <ActionButton
                v-if="!model.isSubmitted"
                variant="success m-2 pl-4 pr-4"
                type="submit"
                i="fas fa-save"
                @click="savePartial(apiActions.UPDATE)"
              >
                Guardar
              </ActionButton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ValidationObserver ref="observer" >
      <div class="dropdown-divider mt-0 pb-2 ml-3 w-100 " />
      <div class="div">
        <div class="col-12 mt-4">
          <section-title content="I. Sección Demográfica" :has-line="true" />
        </div>
        <div class="row ml-2">
          <div class="col-md-3 col-sm-12 pr-5">
            <custom-input
              id="studentSieId"
              v-model="model.studentSieId"
              label="SIE: "
              type="text"
              :disabled="true"
            />
          </div>
          <div class="col-md-3 col-sm-12 mt-2 mt-md-0 mt-sm-2 pr-5">
            <custom-input
              id="studentFullName"
              v-model="model.studentFullName"
              label="Nombre del Estudiante: "
              type="text"
              :disabled="true"
            />
          </div>
        </div>
        <div class="row mt-4 ml-2">
          <div class="col-md-3 col-sm-12 pr-5">
            <ValidationProvider
              v-slot="{ errors }"
              name="edad"
              rules="required"
            >
              <custom-input
                id="age"
                v-model="model.age"
                label="Edad: "
                type="text"
                :disabled="true"
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div class="col-md-3 col-sm-12 mt-2 mt-md-0 mt-sm-2 pr-5">
            <ValidationProvider
              v-slot="{ errors }"
              name="Fecha"
              rules="required"
            >
              <custom-date-picker
                v-model="model.birthDate"
                class-container="w-100"
                label="Fecha de nacimiento: "
                format="dd/MMM./yyyy"
                :value="model.birthDate"
                required
                :disabled="true"
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div class="col-3 col-sm col-12 mt-2 mt-md-0 mt-sm-2 pr-5">
            <ValidationProvider
              v-slot="{ errors }"
              name="género"
              rules="required"
            >
              <custom-drop-down
                v-model="model.gender"
                fieldname="name"
                fieldkey="id"
                label="Género: "
                :options="genders"
                placeholder="Seleccione"
                :value="model.gender"
                :error="errors[0]"
                :disabled="model.isSubmitted"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div class="col-md-3 col-sm-12 mt-2 mt-md-0 mt-sm-2 pr-5">
            <ValidationProvider
              v-slot="{ errors }"
              name="grupo étnico"
              rules="required"
            >
              <custom-drop-down
                v-model="model.ethnicity"
                fieldname="name"
                fieldkey="id"
                label="Grupo Étnico: "
                :options="ethnicGroups"
                placeholder="Seleccione"
                :value="model.ethnicity"
                :error="errors[0]"
                :disabled="model.isSubmitted"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
        </div>

        <div class="row mt-4 ml-2">
          <div class="col-md-6 col-sm col-12 pr-5">
            <ValidationProvider
              v-slot="{ errors }"
              name="direccion 1"
              rules="required"
            >
              <custom-input
                id="dir1"
                v-model="model.address1"
                label="Dirección 1:"
                type="text"
                maxlength="256"
                :error="errors[0]"
                :disabled="model.isSubmitted"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div class="col-md-3 col-sm-12 mt-2 mt-md-0 mt-sm-2 pr-5">
            <ValidationProvider
              v-slot="{ errors }"
              name="zip code"
             :custom-messages="{
                  min: 'El código postal no es válido.',
                  max: 'El código postal no es válido.',
                  required: 'El código postal es requerido.'
                }"
                 rules="required|min:5|max:10"
            >
              <custom-input
                id="zip"
                v-model="model.zipCode"
                label="Zip Code: "
                type="text"
                :mask-type="'Zipcode'"
                placeholder="#####"
                maxlength="10"
                :disabled="model.isSubmitted"
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div class="col-md-3 col-sm-12 pt-0 mt-2 mt-md-0 mt-sm-2 pr-5">
            <ValidationProvider
              v-slot="{ errors }"
              name="estadoSecond"
               :custom-messages="{
                  min: 'El estado no es válido.',    
                  required: 'El campo estado es requerido.'
                }"
              rules="required|min:2"
            >
              <custom-input
                id="state"
                v-model="model.state"
                label="Estado: "
                type="text"
                maxlength="2"
                :disabled="model.isSubmitted"
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
        </div>

        <div class="row mt-4 ml-2">
          <div class="col-md-6 col-sm-12 pr-5">
            <custom-input
              id="dir2"
              v-model="model.address2"
              label="Dirección 2: "
              maxlength="256"
              :disabled="model.isSubmitted"
              type="text"
            />
          </div>
          <div class="col-3 col-sm col-12 pt-0 mt-2 mt-md-0 mt-sm-2 pr-5">
            <ValidationProvider
              v-slot="{ errors }"
              name="municipio "
              rules="required"
            >
              <custom-drop-down
                v-model="model.municipalityStudent"
                fieldname="name"
                fieldkey="id"
                label="Municipio: "
                :options="municipalities" 
                placeholder="Seleccione"
                :disabled="model.isSubmitted"
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div class="col-3 col-sm col-12 pt-0 mt-2 mt-md-0 mt-sm-2 pr-5">
            <ValidationProvider
              v-slot="{ errors }"
               :custom-messages="{
                  completePhone: 'Se deben completar los números telefónicos.',
                  required: 'El campo teléfono es obligatorio',
                }"
              name="teléfono2"
              rules="required|completePhone"
            >
              <custom-input
                id="phone"
                v-model="model.phone"
                label="Teléfono: "
                :mask-type="'Phone'"
                placeholder="(__) __-____"
                :disabled="model.isSubmitted"
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
        </div>

        <div class="col-12 mt-4">
          <section-title content="Información de Ubicación" reverse />
        </div>

        <div class="row mt-4 ml-2">
          <div class="col-md-3 col-sm-12 pt-0 pr-5">
            <ValidationProvider
              v-slot="{ errors }"
              name="municipio"
              rules="required"
            >
              <custom-drop-down
                v-model="model.regionSchool"
                fieldname="name"
                fieldkey="id"
                label="Región: "
                :options="regions"
                placeholder="Seleccione"
                :value="model.regionSchool"
                :disabled="model.isSubmitted"
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
                @input="onRegionChange($event)"
              />
            </ValidationProvider>
          </div>
          <div class="col-md-3 col-sm-12 pt-0 mt-2 mt-md-0 mt-sm-2 pr-5">
            <ValidationProvider
              v-slot="{ errors }"
              name="distrito"
              rules="required"
            >
              <custom-drop-down
                v-model="model.districtSchool"
                fieldname="name"
                fieldkey="id"
                label="Distrito: "
                :options="districts"
                placeholder="Seleccione"
                :disabled="model.isSubmitted"
                :value="model.districtSchool"
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
                @input="onDistrictChange($event)"
              />
            </ValidationProvider>
          </div>
          <div class="col-md-6 col-sm-12 pt-0 mt-2 mt-md-0 mt-sm-2 pr-5">
            <ValidationProvider
              v-slot="{ errors }"
              name="escuela"
              rules="required"
            >
              <custom-drop-down
                v-model="model.school"
                fieldname="name"
                fieldkey="id"
                label="Escuela: "
                :options="schools"
                placeholder="Seleccione"
                :value="model.school"
                :disabled="model.isSubmitted"
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
        </div>

        <div class="col-12 mt-4">
          <section-title
            content="II. Información de Contacto del Estudiante"
            :has-line="true"
          />
        </div>

        <div class="col-12">
          <ValidationProvider v-slot="{ errors }" mode="eager" rules="required">
            <WizardQuestion
              id="qPreQuestionsA"
              v-model="model.studentWasContacted"
              bold-text
              description="Se logró comunicación con el estudiante:"
              display-number="1"
              :has-attached-warning="true"
              warning-message="De contestar “NO”, favor indicar las gestiones realizadas para contactar al estudiante. (0552)"
              :answer-control-type="8"
              :option-list-value="optionsYesNoList"
              :has-icon="false"
              :hide-icon-box="true"
              :is-yes-no-answer="false"
              :data-selectedAnswer="2"
              :is-disabled="model.isSubmitted"
              error-message="mensaje"
              class="custom-wizard-question"
            />
            <Error
              v-if="errors[0]"
              variant="no-border error-margin-left error-custom"
              :message="messages.questionRequired"
            />
          </ValidationProvider>
          <div v-if="model.studentWasContacted == no" class="row px-5 py-3">
            <div class="col-12">
              <ValidationProvider
                v-slot="{ errors }"
                name="comentario"
                rules="required"
              >
                <CustomTextArea
                  id="id"
                  v-model="model.studentWasContactedComment"
                  :show-char-count="true"
                  :maxlength="500"
                  label="Comentario: "
                  :error="errors[0]"
                  :disabled="model.isSubmitted"
                  :custom-error-msg="resources['R03200159']"
                  placeholder="Escribir comentario..."
                />
              </ValidationProvider>
            </div>
          </div>

          <div v-if="model.studentWasContacted == si" class="item-pane">
            <div class="row mt-4 ml-5">
              <div class="col-4 col-sm col-12 pb-0">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Nombre"
                  rules="required"
                >
                  <custom-input
                    id="nameContact"
                    v-model="model.personInChargeName"
                    label="Nombre: "
                    :disabled="model.isSubmitted"
                    :error="errors[0]"
                    :custom-error-msg.sync="errors[0]"
                  />
                </ValidationProvider>
              </div>
              <div class="col-4 col-sm col-12 pt-0 mt-2 mt-md-0 mt-sm-2">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="parentesco"
                  rules="required"
                >
                  <custom-drop-down
                    v-model="model.personInChargeTypeId"
                    fieldname="name"
                    fieldkey="id"
                    label="Parentesco: "
                    :disabled="model.isSubmitted"
                    :options="relationships"
                    placeholder="Seleccione"
                    :error="errors[0]"
                    :custom-error-msg.sync="errors[0]"
                  />
                </ValidationProvider>
              </div>
              <div class="col-4" />
            </div>
            <div class="row mt-4 ml-5">
              <div class="col-6 col-sm col-12 pb-0">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="direccion 1"
                  rules="required"
                >
                  <custom-input
                    id="dirContact"
                    v-model="model.personInChargeAddressLine1"
                    label="Dirección 1: "
                    type="text"
                    maxlength="256"
                    :disabled="model.isSubmitted"
                    :error="errors[0]"
                    :custom-error-msg.sync="errors[0]"
                  />
                </ValidationProvider>
              </div>
              <div class="col-3 col-sm col-12 pt-0 mt-2 mt-md-0 mt-sm-2">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="zipCode"
                  :custom-messages="{
                  min: 'El código postal no es válido.',
                  max: 'El código postal no es válido.',
                  required: 'El código postal es requerido.'
                }"
                 rules="required|min:5|max:10"
                >
                  <custom-input
                    id="zipContact"
                    v-model="model.personInChargeZipCode"
                    label="Zip Code: "
                    type="text"
                    :mask-type="'Zipcode'"
                    placeholder="#####"
                    :disabled="model.isSubmitted"
                    maxlength="10"
                    :error="errors[0]"
                    :custom-error-msg.sync="errors[0]"
                  />
                </ValidationProvider>
              </div>
              <div class="col-3 col-sm col-12 pt-0 mt-2 mt-md-0 mt-sm-2">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="estado"
                  :custom-messages="{
                  min: 'El estado no es válido.',    
                  required: 'El campo estado es requerido.'
                }"
              rules="required|min:2"
                >
                  <custom-input
                    id="stateContact"
                    v-model="model.personInChargeAddressState"
                    label="Estado: "
                    type="text"
                    :disabled="model.isSubmitted"
                    maxlength="2"
                    :error="errors[0]"
                    :custom-error-msg.sync="errors[0]"
                  />
                </ValidationProvider>
              </div>
            </div>
            <div class="row mt-4 ml-5">
              <div class="col-6 col-sm col-12 pb-0">
                <custom-input
                  id="dir2Contact"
                  v-model="model.personInChargeAddressLine2"
                  label="Direccion 2: "
                  type="text"
                  maxlength="256"
                  :disabled="model.isSubmitted"
                />
              </div>
              <div class="col-3 col-sm col-12 pt-0 mt-2 mt-md-0 mt-sm-2">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="municipio"
                  rules="required"
                >
                  <custom-drop-down
                    v-model="model.personInChargeAddressCityId"
                    fieldname="name"
                    fieldkey="id"
                    label="Municipio: "
                    :options="municipalities"
                    :disabled="model.isSubmitted"
                    placeholder="Seleccione"
                    :error="errors[0]"
                    :custom-error-msg.sync="errors[0]"
                  />
                </ValidationProvider>
              </div>
              <div class="col-3 col-sm col-12 pt-0 mt-2 mt-md-0 mt-sm-2">
                <ValidationProvider
                    v-slot="{ errors }"
               :custom-messages="{
                  completePhone: 'Se deben completar los números telefónicos.',
                  required: 'El campo teléfono es obligatorio',
                }"
                              rules="required|completePhone"
                  name="teléfono"
                
                >
                  <custom-input
                    id="phoneContact"
                    v-model="model.personInChargePhoneNumber"
                    label="Teléfono:"
                    :mask-type="'Phone'"
                    placeholder="(__) __-____"
                    :disabled="model.isSubmitted"
                    :error="errors[0]"
                    :custom-error-msg.sync="errors[0]"
                  />
                </ValidationProvider>
              </div>
            </div>
            <div class="row mt-4 ml-5">
              <div class="col-6 col-sm col-12 pb-0 pl-3">
                <input
                  type="checkbox"
                  :name="'validoDir'"
                  :disabled="model.isSubmitted"
                  class="option-input checkbox"
                />
                <label class="mb-0" :for="'validoDir'">
                  <span><i class="ic-check" /></span>
                </label>
                <span class="use-label pl-3">Se validó la dirección</span>
              </div>
            </div>
          </div>
        </div>

        <div v-if="model.studentWasContacted == si">
          <div class="col-12">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <WizardQuestion
                id="qPreQuestionsB"
                :ref="'RefhasInitialEvaluationFlag'"
                v-model="model.studentKeepStuding"
                bold-text
                description="<div class='mt-2'>¿Sigue estudiando?</div>"
                :answer-control-type="8"
                :option-list-value="optionsYesNoList"
                display-number="2"
                :has-icon="false"
                :is-disabled="model.isSubmitted"
                :hide-icon-box="true"
                error-message="mensaje"
                class="custom-wizard-question"
              />
              <Error
                v-if="errors[0]"
                variant="no-border error-margin-left error-custom"
                :message="messages.questionRequired"
              />
            </ValidationProvider>

            <div v-if="model.studentKeepStuding == si">
              <div class="item-pane">
                <div class="row mt-4 ml-5">
                  <div class="col-4 col-sm col-12 pb-0 pl-3">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="donde sigue estudiando"
                      rules="required"
                    >
                      <custom-drop-down
                        v-model="model.studentStudingPlace"
                        fieldname="name"
                        fieldkey="id"
                        label="Indique dónde está estudiando: "
                        :disabled="model.isSubmitted"
                        :options="studyPlaces"
                        placeholder="Seleccione"
                        :error="errors[0]"
                        :custom-error-msg.sync="errors[0]"
                      />
                    </ValidationProvider>
                  </div>
                  <div class="col-4" />
                  <div class="col-4" />
                </div>
              </div>
              <div
                v-if="
                  model.studentStudingPlace &&
                    model.studentStudingPlace.id == other
                "
                class="row px-5 py-3"
              >
                <div class="col-12">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="comentario"
                    rules="required"
                  >
                    <custom-text-area
                      id="id"
                      v-model="model.studentStudingPlaceComment"
                      :maxlength="500"
                      :show-char-count="true"
                      :disabled="model.isSubmitted"
                      label="Comentario: "
                      :error="errors[0]"
                      :custom-error-msg="resources['R03200159']"
                      placeholder="Escribir comentario..."
                    />
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div v-if="model.studentKeepStuding == no" class="row px-5 py-3">
              <div class="col-12">
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <CustomTextArea
                    id="id"
                    v-model="model.studentKeepStudingComment"
                    :show-char-count="true"
                    :maxlength="500"
                    label="Comentario:"
                    :disabled="model.isSubmitted"
                    :error="errors[0]"
                    :custom-error-msg="resources['R03200159']"
                    placeholder="Escribir comentario..."
                  />
                </ValidationProvider>
              </div>
            </div>
          </div>

          <div class="col-12">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <WizardQuestion
                id="qPreQuestionsC"
                :ref="'RefhasInitialEvaluationFlag'"
                v-model="model.studentIsWorking"
                bold-text
                description="<div class='mt-2'>¿Está trabajando?</div>"
                :answer-control-type="8"
                :option-list-value="optionsYesNoList"
                display-number="3"
                :has-icon="false"
                :hide-icon-box="true"
                :is-disabled="model.isSubmitted"
                error-message="mensaje"
                class="custom-wizard-question"
              />
              <Error
                v-if="errors[0]"
                variant="no-border error-margin-left error-custom"
                :message="messages.questionRequired"
              />
            </ValidationProvider>
            <div v-if="model.studentIsWorking == si">
              <div class="item-pane">
                <div class="row mt-4 ml-5">
                  <div class="col-4 col-sm col-12 pb-0 pl-3">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="tipo de empleo"
                      rules="required"
                    >
                      <custom-drop-down
                        v-model="model.studentEmploymentType"
                        fieldname="name"
                        fieldkey="id"
                        label="Indique qué tipo de empleo: "
                        :options="jobTypes"
                        :disabled="model.isSubmitted"
                        placeholder="Seleccione"
                        :error="errors[0]"
                        :custom-error-msg.sync="errors[0]"
                      />
                    </ValidationProvider>
                  </div>
                  <div class="col-4" />
                  <div class="col-4" />
                </div>
              </div>

              <div
                v-if="
                  model.studentEmploymentType &&
                    model.studentEmploymentType.id == other
                "
                class="row px-5 py-3"
              >
                <div class="col-12">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="comentario"
                    rules="required"
                  >
                    <custom-text-area
                      id="id"
                      v-model="model.studentEmploymentTypeComment"
                      :maxlength="500"
                      :show-char-count="true"
                      :disabled="model.isSubmitted"
                      label="Comentario: "
                      :error="errors[0]"
                      :custom-error-msg="resources['R03200159']"
                      placeholder="Escribir comentario..."
                    />
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div v-if="model.studentIsWorking == no" class="row px-5 py-3">
              <div class="col-12">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="comentario"
                  rules="required"
                >
                  <custom-text-area
                    id="id"
                    v-model="model.studentIsWorkingComment"
                    :maxlength="500"
                    :show-char-count="true"
                    :disabled="model.isSubmitted"
                    label="Comentario: "
                    :error="errors[0]"
                    :custom-error-msg="resources['R03200159']"
                    placeholder="Escribir comentario..."
                  />
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div v-if="model.studentIsWorking == si" class="col-12">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <WizardQuestion
                id="qPreQuestionsD"
                :ref="'RefhasInitialEvaluationFlag'"
                v-model="model.studentIsReceivingMinium"
                bold-text
                description="<div class='mt-2'>¿Recibe $7.25 por hora (Mínimo Federal)?</div>"
                display-number="4"
                :answer-control-type="8"
                :option-list-value="optionsList"
                :has-icon="false"
                :is-disabled="model.isSubmitted"
                :hide-icon-box="true"
                error-message="mensaje"
                class="custom-wizard-question"
              />
              <Error
                v-if="errors[0]"
                variant="no-border error-margin-left error-custom"
                :message="messages.questionRequired"
              />
            </ValidationProvider>
            <div
              v-if="model.studentIsReceivingMinium == no"
              class="row px-5 py-3"
            >
              <div class="col-12">
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <custom-text-area
                    id="id"
                    v-model="model.studentIsReceivingMiniumComment"
                    :show-char-count="true"
                    :maxlength="500"
                    label="Comentario: "
                    :error="errors[0]"
                    :disabled="model.isSubmitted"
                    :custom-error-msg="resources['R03200159']"
                    placeholder="Escribir comentario..."
                  />
                </ValidationProvider>
              </div>
            </div>
          </div>

          <div v-if="model.studentIsWorking == si" class="col-12">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <WizardQuestion
                id="qPreQuestionsE"
                :ref="'RefhasInitialEvaluationFlag'"
                v-model="model.studentIsWorkingFulltime"
                bold-text
                description="<div class='mt-2'>¿Trabaja a tiempo completo?</div>"
                display-number="5"
                :answer-control-type="8"
                :option-list-value="optionsList"
                :is-disabled="model.isSubmitted"
                :has-icon="false"
                :hide-icon-box="true"
                error-message="mensaje"
                class="custom-wizard-question"
              />
              <Error
                v-if="errors[0]"
                variant="no-border error-margin-left error-custom"
                :message="messages.questionRequired"
              />
            </ValidationProvider>
            <div
              v-if="model.studentIsWorkingFulltime == no"
              class="col-12 px-5 py-3"
            >
              <div class="col-12">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="comentario"
                  rules="required"
                >
                  <custom-text-area
                    id="id"
                    v-model="model.studentIsWorkingFulltimeComment"
                    :maxlength="500"
                    :show-char-count="true"
                    label="Comentario:"
                    :error="errors[0]"
                    :disabled="model.isSubmitted"
                    :custom-error-msg="resources['R03200159']"
                    placeholder="Escribir comentario..."
                  />
                </ValidationProvider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ValidationObserver>
    <div v-if="!model.isSubmitted">
      <div class="col-12 text-right align-self-end mt-5 mr-3 pb-0">
        <div class="dropdown-divider mt-3 w-100 " />
        <ActionButton
          variant="success m-2 pl-4 pr-4"
          i="fas fa-save"
          @click="savePartial(apiActions.UPDATE)"
        >
          Guardar
        </ActionButton>
      </div>
    </div>
  </div>
</template>

<script>
import CustomInput from '@/components/common/CustomInput';
import CustomDropDown from '@/components/common/CustomDropDown';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import CustomTextArea from '@/components/common/CustomTextArea';
import SectionTitle from '@/components/pei/shared/SectionTitle.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import TitleBreadCrumb from '@/components/common/page/TitleBreadcrumb.vue';
import { ActionButton } from '@/components/common';
import alert from '@/mixin/alert.mixin';
import WizardQuestion from '@/components/pei/WizardQuestion';
import Error from '@/components/common/Error.vue';
import resourcesService from '@/services/resources.js';

export default {
  name: 'EgressQuestionnaire',
  data() {
    return {
      resources: [],
      page: {
        icon: 'fas fa-user-circle',
        title: 'Cuestionario de Egreso',
        routes: ['PEI', 'Cuestionario de Egreso'],
      },
      optionsList: [
        { Display: 'Sí', Value: 1 },

        { Display: 'No', Value: 2 },

        { Display: 'N/A', Value: 10 },
      ],
      optionsYesNoList: [
        { Display: 'Sí', Value: 1 },

        { Display: 'No', Value: 2 },
      ],
      messages: { questionRequired: 'Debe seleccionar una respuesta.' },
      districts: [],
      relationships: [],
      municipalities: [],
      schools: [],
      regions: [],
      genders: [],
      ethnicGroups: [],
      jobTypes: [],
      studyPlaces: [],
      model: {},
      other: 16,
      si: 1,
      no: 2,
      apiActions: {
        SAVE: 'save',
        SUBMIT: 'submit',
        UPDATE: 'update',
      },
    };
  },
  mixins: [alert],
  components: {
    CustomInput,
    CustomDropDown,
    SectionTitle,
    TitleBreadCrumb,
    ActionButton,
    CustomDatePicker,
    WizardQuestion,
    CustomTextArea,
    ValidationObserver,
    ValidationProvider,
    Error,
  },
  async mounted() {
    this.model = { studentExitId: this.$route.params.studentExitId };
    this.FetchEgressQuestionaire();
    this.FetchJobsType();
    this.FetchStudyPlaces();
    this.FetchPersonInCharge();
    this.FetchMnicipalities();
    this.FetchEthnicitycodes();
    this.FetchGenders();
    this.loadResources();
  },
  methods: {
    async FetchStudyPlaces() {
      this.$ApiGet('/api/questionnaire/answersbyquestion/19')
        .then((res) => {
          this.studyPlaces = res.data;
        })
        .catch((err) => this.ShowToast(err.message, '', 'error'));
    },
    async FetchGenders() {
      this.$ApiGet('/api/code/getgendercodes')
        .then((res) => {
          this.genders = res.data;
        })
        .catch((err) => this.ShowToast(err.message, '', 'error'));
    },
    async FetchEthnicitycodes() {
      this.$ApiGet('/api/code/getstudentethnicitycodes')
        .then((res) => {
          this.ethnicGroups = res.data;
        })
        .catch((err) => this.ShowToast(err.message, '', 'error'));
    },
    async FetchMnicipalities() {
      this.$ApiGet('/api/schools/municipalities')
        .then((res) => {
          this.municipalities = res.data;
        })
        .catch((err) => this.ShowToast(err.message, '', 'error'));
    },

    async FetchDistricts() {
      this.$ApiGet(
        '/api/schools/types/regions/districts?AcademicYear=' +
          this.model.academicYearId +
          '&RegionId=' +
          this.model.regionSchool.id
      )
        .then((res) => {
          this.districts = res.data;
        })
        .catch((err) => this.ShowToast(err.message, '', 'error'));
    },
    async FetchRegions() {
      this.$ApiGet(
        '/api/schools/types/regions?AcademicYear=' + this.model.academicYearId
      )
        .then((res) => {
          this.regions = res.data;
        })
        .catch((err) => this.ShowToast(err.message, '', 'error'));
    },
    async FetchPersonInCharge() {
      this.$ApiGet('/api/code/getpersoninchargetype')
        .then((res) => {
          this.relationships = res.data;
        })
        .catch((err) => this.ShowToast(err.message, '', 'error'));
    },
    async FetchSchools() {
      this.$ApiGet(
        '/api/schools?AcademicYear=' +
          this.model.academicYearId +
          '&districtId=' +
          this.model.districtSchool.id
      )
        .then((res) => {
          this.schools = res.data;
        })
        .catch((err) => this.ShowToast(err.message, '', 'error'));
    },
    async FetchJobsType() {
      this.$ApiGet('api/questionnaire/answersbyquestion/21')
        .then((res) => {
          this.jobTypes = res.data;
        })
        .catch((err) => this.ShowToast(err.message, '', 'error'));
    },
    async FetchEgressQuestionaire() {
      this.$ApiGet(
        '/api/studentexitinterview/getstudentexit?studentExitId=' +
          this.model.studentExitId
      )
        .then((res) => {
          this.model = res.data;
          this.model.birthDate = new Date(res.data.birthDate);
          if (this.model.postSchoolOutcomeSubmitId == 0) {
            this.model.postSchoolOutcomeSubmitId = null;
          }

          if (this.model.zipCode?.match(/[a-z A-Z]/gi)) {
            this.model.zipCode = null;
          }

          if (
            this.model.municipalityStudent &&
            this.model.municipalityStudent.id == 0
          ) {
            this.model.municipalityStudent = null;
          }

          if (
            this.model.personInChargeAddressCityId &&
            this.model.personInChargeAddressCityId.id == 0
          ) {
            this.model.personInChargeAddressCityId = null;
          }

          this.FetchDistricts();
          this.FetchSchools();
          this.FetchRegions();
        })
        .catch((err) => this.ShowToast(err.message, '', 'error'));
    },
    async onRegionChange(item) {
      this.model.school = null;
      this.model.districtSchool = null;
      this.districts = [];
      this.schools = [];
      if (item) this.FetchDistricts();
    },
    onDistrictChange(item) {
      this.model.school = null;
      this.schools = [];
      if (item) this.FetchSchools();
    },
    processQuestionnaire(action) {
      this.$ApiPost(`api/studentexit/${action}`, this.modelMapped).then(
        ({ data }) => {
          this.model.postSchoolOutcomeSubmitId = data.postSchoolOutcomeSubmitId;
          if (action == this.apiActions.SUBMIT) {
            this.model.isSubmitted = true;
          }
          this.ShowToast(
            'Proceso exitoso.',
            'Los datos fueron guardados exitosamente.',
            this.toastType.Success
          );
        }
      );
    },
    async savePartial(action) {
       const isValid = await this.$refs.observer.validate();
        if (isValid) {
      if (
        this.model.postSchoolOutcomeSubmitId == null &&
        action == this.apiActions.UPDATE
      ) {
        action = this.apiActions.SAVE;
      }
      this.processQuestionnaire(action);
        }
    },
    async handleSubmit(action) {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        if (
          this.model.postSchoolOutcomeSubmitId == null &&
          action == this.apiActions.UPDATE
        ) {
          action = this.apiActions.SAVE;
        }
        this.processQuestionnaire(action);
      }
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        'R03200159',
      ]);
    },
  },
  computed: {
    modelMapped() {
      let model = this.model;

      let data = {
        egressSubmit: {
          postSchoolOutcomeSubmitId: model.postSchoolOutcomeSubmitId,
          studentExitId: model.studentExitId,
          studentSieId: model.studentSieId,
          isSubmitted: model.isSubmitted,
          submittedDate: model.submittedDate,
          personInChargeName: model.personInChargeName,
          personInChargePhoneNumber: model.personInChargePhoneNumber
            ? model.personInChargePhoneNumber.replace(/-/g, '')
            : null,
          studentAddressLine1: model.address1,
          studentAddressLine2: model.address2,
          personInChargeAddressLine1: model.personInChargeAddressLine1,
          personInChargeAddressLine2: model.personInChargeAddressLine2,
          studentAddressCityId: model.municipalityStudent
            ? model.municipalityStudent.id
            : null,
          personInChargeAddressCityId: model.personInChargeAddressCityId
            ? model.personInChargeAddressCityId.id
            : null,
          studentAddressState: model.state,
          personInChargeAddressState: model.personInChargeAddressState,
          personInChargeZipCode: model.personInChargeZipCode,
          studentZipCode: model.zipCode,
          studentPhoneNumber: model.phone
            ? model.phone.replace(/-/g, '')
            : null,
          studentEthnicityId: model.ethnicity ? model.ethnicity.id : null,
          studentGenderId: model.gender ? model.gender.id : null,
          personInChargeTypeId: model.personInChargeTypeId
            ? model.personInChargeTypeId.id
            : null,
        },
        egressAnswers: [
          {
            questionnaireQuestionId: 17,
            questionnaireAnswerId: model.studentWasContacted,
            postSchoolOutcomeSubmitId: model.postSchoolOutcomeSubmitId,
            openAnswer: model.studentWasContactedComment,
          },
          {
            questionnaireQuestionId: 18,
            questionnaireAnswerId: model.studentKeepStuding || 0,
            postSchoolOutcomeSubmitId: model.postSchoolOutcomeSubmitId,
            openAnswer: model.studentKeepStudingComment || '',
          },
          {
            questionnaireQuestionId: 20,
            questionnaireAnswerId: model.studentIsWorking || 0,
            postSchoolOutcomeSubmitId: model.postSchoolOutcomeSubmitId,
            openAnswer: model.studentIsWorkingComment || '',
          },
          {
            questionnaireQuestionId: 22,
            questionnaireAnswerId: model.studentIsReceivingMinium || 0,
            postSchoolOutcomeSubmitId: model.postSchoolOutcomeSubmitId,
            openAnswer: model.studentIsReceivingMiniumComment || '',
          },
          {
            questionnaireQuestionId: 23,
            questionnaireAnswerId: model.studentIsWorkingFulltime || 0,
            postSchoolOutcomeSubmitId: model.postSchoolOutcomeSubmitId,
            openAnswer: model.studentIsWorkingFulltimeComment || '',
          },
        ],
      };

      if (model.studentEmploymentType) {
        data.egressAnswers.push(
          //Indique qué tipo de empleo
          {
            questionnaireQuestionId: 21,
            questionnaireAnswerId: model.studentEmploymentType.id,
            postSchoolOutcomeSubmitId: model.postSchoolOutcomeSubmitId,
            openAnswer: model.studentEmploymentTypeComment,
          }
        );
      }

      if (model.studentStudingPlace) {
        data.egressAnswers.push(
          //Indique dónde está estudiando
          {
            questionnaireQuestionId: 19,
            questionnaireAnswerId: model.studentStudingPlace.id,
            postSchoolOutcomeSubmitId: model.postSchoolOutcomeSubmitId,
            openAnswer: model.studentStudingPlaceComment,
          }
        );
      }

      return data;
    },
  },
};
</script>

<style scoped>
.checkbox-container {
  border-radius: 5px 0 0 5px;
}

.checkbox-container .input {
  height: 20px;
  width: 20px;
  border-radius: 4px;
}
.green-box {
  color: white;
}
.green-box .input {
  background-color: white;
  color: #2db782;
  border: 2px solid #e2e2e2;
}
.green-box .input::after {
  content: '\f00c';
  color: #2db782;
  font-size: 14px;
}
</style>
